export default __webpack_public_path__ + "static/media/7、首页果汁茶.1e8e87a6.jpg";